import React from 'react';


const Footer = ()=>{

    return(
    <>
        <footer>
            <div className="container-fluid ">
                <div className="row">
                    <div className="col-12 col-lg-4 col-xl-4 col-wrap">
                        <div className="footer-section">
                            <h2>
                                Contact us
                            </h2>
                            <p>
                                Need to get in touch with the LUMS Alumni Association ?
                            </p>
                            <div className="social-icons">
                                <a href="/"><i className="fa fa-instagram"></i></a>
                                <a href="/"><i className="fa fa-facebook"></i></a>
                                <a href="/"><i className="fa fa-linkedin"></i></a>
                                <a href="/"><i className="fa fa-twitter"></i></a>
                                <a href="/"><i className="fa fa-soundcloud"></i></a>
                                <a href="/"><i className="fa fa-youtube"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 col-xl-4 col-wrap">
                        <div className="footer-section">
                            <h5>
                                Postal Address
                            </h5>
                            <p>
                               Alumni Relations, LUMS DHA Lahore Cantt. 54792, Lahore, Pakistan
                            </p>
                            <h5>
                                Office Hours
                            </h5>
                            <p>
                                Monday - Friday <br/> 
                                8:30 am - 5:00 pm
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 col-xl-4 col-wrap">
                        <div className="footer-section">
                            <h5>
                                Email Address
                            </h5>
                            <p>
                                Nuzhat Kamran <br/> 
                                Director – Office of Advancement <br/> 
                                nuzhat.kamran@lums.edu.pk
                            </p>
                            <h5>
                                UAN
                            </h5>
                            <h5>
                            +92 42 3560 8000
                            </h5>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12"></div>
                </div>
            </div>
        </footer>
        <div className="footer-bottom">
                2021 © Lahore University of Management Sciences. All Rights Reserved
        </div>
    </>    
    );

}

//React.memo() will store the component when its rendered for the first time and 
//will only change it and render it again when incoming components will have some changed values in them
//we will not use React.memo if props in the component change everytime ..w e will only use it when there are no props 
//or the props remain same in that component every time

export default React.memo(Footer);